// extracted by mini-css-extract-plugin
export default {"select":"styles_select__YcLs4","withValue":"styles_withValue__fYOLh","inline":"styles_inline__DDiXg"};